
<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Entrega"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <entrega-form-atualizar
            operacao="A"
            :entrega="entrega"
            :acao="acao"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></entrega-form-atualizar>
    </div>
</template>

<script>
import EntregaFormAtualizar from './EntregaFormAtualizar'

export default {
    components: {
        EntregaFormAtualizar
    },

    props: {
        entrega: {
            type: Object,
            default: () => {}
        },
        acao: {
            type: Object,
            default: () => ({})
        },
        dataServicos: {
            type: Object
        },
    },

    data() {
        return {
            mostrarModal: false,
            erros: []
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(entrega) {
            
            this.$store.dispatch('addRequest')

            let entregaDto ={};

            entregaDto = entrega;
            // entregaDto = {
            //     nomeConsultoria: enrtega.nomeConsultoria,
            //     totalPrevisto: consultoria.totalPrevisto,
            //     totalRealizado: consultoria.totalRealizado,
            //     idConsultoria:consultoria.idConsultoria,
            //     idAcaoPlanoTrabalho: consultoria.idAcaoPlanoTrabalho
            // }
            this.dataServicos.alterarEntrega(entregaDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Entrega atualizada com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarLista')
                        this.fecharModal()
                    } else {
                        this.$emit('atualizarErros', response.errors);
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
        
            
    },
}
</script>
